import Api from '../../api/unlicensedCarOutIn'
export default {
  namespace: 'faceCompare', // 注意定义namespace, 将会在store中存储
  state: {
    sourceList: [],
  },
  getters: {
    sourceList: state => state.sourceList,

  },
  actions: {
  },
  mutations: {
    mutationsSourceList (state, value) {
      state.sourceList = value
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/faceCompare.js